import ActionsButton   from '@/components/actionsButton/ActionsButton';
import Image           from '@/components/Image/Image';
import ContactModel    from '@/models/services/network/ContactModel';
import FileModel       from '@/models/services/file/FileModel';
import useFile         from '@/hooks/useFile';
import { Box }         from '@chakra-ui/react';
import { Text }        from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export interface IEntityManagerRowProps {
	manager:     ContactModel;
	file?:       FileModel;
	onDelete:    () => void;
	isReadOnly?: boolean;
}

const EntityManagerRow = ({ manager, file, onDelete, isReadOnly }: IEntityManagerRowProps) => {
	const { t }      = useTranslation();
	const { source } = useFile(file);

	return (
		<Box display="flex" alignItems="center" justifyContent="space-between" py="8px">
			<Box display="flex" alignItems="center" gap="15px">
				<Box minWidth="42px" maxWidth="42px" height="42px">
					<Image errorSize="sm" type="profile" borderRadius="full" src={manager.get('photoUrl') || source} width="42px" height="42px" objectFit="cover" />
				</Box>
				<Box display="flex" flexDirection="column" gap="2px">
					<Text lineHeight="1" className="poppins-semibold" fontSize="14px">{manager.fullName}</Text>
					<Text lineHeight="1" fontSize="12px" color="gray.500">{manager.email}</Text>
				</Box>
			</Box>
			<ActionsButton actions={[
				{ label: t('app.actions.unassign'), type: 'remove', do: onDelete, disabled: isReadOnly },
			]} />
		</Box>
	);
};

export default EntityManagerRow;
